import { addColumns } from "@nozbe/watermelondb/Schema/migrations";

export default {
  toVersion: 20,
  steps: [
    addColumns({
      table: "messages",
      columns: [{ name: "order_details", type: "string" }],
    }),
  ],
};
